if (typeof boostPFSThemeConfig != "undefined") {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: false,
      stickyProductHeightLimitParam: 0,
    },
  }
}

; (function () {
  // fix split back safari
  /*
  window.addEventListener("pageshow", function(evt){
        if(evt.persisted && Utils.isSafari()){
            document.querySelector(".SectionHeader").style.opacity = "0";
            const desInterval = setInterval(desTimer, 200);
            function desTimer() {
               let itemDes = document.querySelector(".boost-pfs-filter-collection-description");
              let des = itemDes?.innerHTML || null;

              if(des == null) {
                document.querySelector(".SectionHeader").style.opacity = "1";
                clearInterval(desInterval);
                return
              };
              let txtArray = des.split("####");
              if(des.includes("####") && txtArray.length != 0){
                itemDes.innerHTML = txtArray[0];
                document.querySelector(".SectionHeader").style.opacity = "1";
                // clearInterval(desInterval);
              }
            }
            setTimeout(function(){
                document.querySelector(".SectionHeader").style.opacity = "1";
                clearInterval(desInterval);
            },1300)
      }
  }, false);
  */
  // end fix split back safari

  BoostPFS.inject(this)
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {

    var fadeElement = ""
    fadeElement = jQ(".PageTransitionBoost")
    if (fadeElement) {
      fadeElement.addClass("active")
    }
    if (!data) data = this.data

    let earlyAccessProducts = window.earlyAccessProducts
    earlyAccessProducts = earlyAccessProducts.map(String)

    let editionProductId = data.id
    editionProductId = editionProductId.toString()



    let earlyAccessCollectionHandles = window.earlyAccessCollectionHandles
    let collectionHandle = window.collectionHandle





    // Check if the data.id is in the earlyAccessProducts arra


    if (!index) index = this.index
    var soldOut = !data.available,
      onSale = data.compare_at_price_min > data.price_min,
      priceVaries = data.price_min != data.price_max,
      images = data.images_info
    if (images.length == 0) {
      images.push({
        src: boostPFSConfig.general.no_image_url,
        id: data.id,
        width: 480,
        height: 480,
      })
    }







    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0]
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant")
      })
      if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0]
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i]
          break
        }
      }
    }

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml




    if (earlyAccessProducts.includes(editionProductId) == false || earlyAccessCollectionHandles.includes(collectionHandle) == true || window.earlyAccessCustomer == true) {

      //Promo image
      itemHtml = itemHtml.replace(/{{the_promo_image}}/g, promoImage(data, index))

      //Add class
      itemHtml = itemHtml.replace(/{{mobile_items_per_row}}/g, boostPFSConfig.custom.mobile_items_per_row)
      itemHtml = itemHtml.replace(/{{tablet_items_per_row}}/g, boostPFSConfig.custom.tablet_items_per_row)
      itemHtml = itemHtml.replace(/{{desktop_items_per_row}}/g, boostPFSConfig.custom.desktop_items_per_row)
      itemHtml = itemHtml.replace(/{{horizontal_class}}/g, boostPFSConfig.custom.horizontal_class)
      itemHtml = itemHtml.replace(/{{filter_position_class}}/g, boostPFSConfig.custom.filter_position)

      var has_alternate_image = false
      if (
        images.length > 1 &&
        boostPFSConfig.custom.hasOwnProperty("product_show_secondary_image") &&
        boostPFSConfig.custom.product_show_secondary_image == true
      ) {
        has_alternate_image = true
      }
      itemHtml = itemHtml.replace(
        /{{has_alternate_image_class}}/g,
        has_alternate_image ? "ProductItem__ImageWrapper--withAlternateImage" : ""
      )

      var use_natural_size = false
      if (
        (boostPFSConfig.custom.hasOwnProperty("product_image_size") &&
          boostPFSConfig.custom.product_image_size == "natural") ||
        boostPFSThemeConfig.custom.use_horizontal
      ) {
        use_natural_size = true
      }
      itemHtml = itemHtml.replace(
        /{{use_natural_size_class}}/g,
        use_natural_size ? "withFallback" : boostPFSConfig.custom.product_image_size
      )
      var media_aspect_ratio = images[0].width / images[0].height
      var max_width = images[0].width
      if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125
      itemHtml = itemHtml.replace(
        /{{padding_bottom}}/g,
        use_natural_size ? "padding-bottom: " + 100 / media_aspect_ratio + "%;" : ""
      )
      itemHtml = itemHtml.replace(/{{media_aspect_ratio}}/g, media_aspect_ratio)
      itemHtml = itemHtml.replace(/{{max_width}}/g, max_width)

      var sizes0 = "200,400,600,700,800,900,1000,1200"
      var image_url = Utils.optimizeImage(images[0]["src"], "{width}x")
      itemHtml = itemHtml.replace(/{{image_url}}/g, image_url)
      itemHtml = itemHtml.replace(/{{supported_sizes}}/g, imageSize(sizes0, images[0]))
      itemHtml = itemHtml.replace(/{{featured_media_id}}/g, images[0].id)
      var featured_media_url = Utils.optimizeImage(images[0]["src"], "600x")
      itemHtml = itemHtml.replace(/{{featured_media_url}}/g, featured_media_url)

      var alternate_image = ""

      if (has_alternate_image && images.length > 1) {
        var index = 1

        if (images.length > 4) index = 4

        var sizes1 = "200,300,400,600,800,900,1000,1200"
        var thumbUrl = Utils.optimizeImage(images[index]["src"], "{width}x")
        alternate_image +=
          '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' +
          thumbUrl +
          '" data-widths="[' +
          imageSize(sizes1, images[index]) +
          ']"  data-sizes="auto" alt="' +
          data.title +
          '" data-image-id="' +
          images[index].id +
          '">'
      }
      itemHtml = itemHtml.replace(/{{alternate_image}}/g, alternate_image)

      var product_media1_url = featured_media_url
      if (images.length > 1) {
        product_media1_url = Utils.optimizeImage(images[1]["src"], "600x")
      }
      itemHtml = itemHtml.replace(/{{product_media1_url}}/g, product_media1_url)

      // Add Label
      itemHtml = itemHtml.replace(/{{product_labels}}/g, buildLabels(data))

      // Add main attribute (Always put at the end of this function)
      itemHtml = itemHtml.replace(/{{product_info}}/g, buildInfo(data, index))

      var view_product = boostPFSConfig.custom.use_horizontal
        ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' +
        boostPFSConfig.label.view_product +
        "</a>"
        : ""
      itemHtml = itemHtml.replace(/{{view_product}}/g, view_product)

      // Add Reviews
      if (typeof Integration === "undefined" || !Integration.hascompileTemplate("reviews")) {
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, "")
      }

      itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
      itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());

      // itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));


      itemHtml = itemHtml.replace(/{{itemUrl}}/g, window.collectionHandle + '/' + 'products' + "/" + data.handle);

    } else {
      itemHtml = ""
    }


    return itemHtml
  }

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildClass() {
    return boostPFSConfig.custom.filter_position == "drawer" ? "lap-and-up" : "desk"
  }

  function buildClassHiz() {
    return boostPFSConfig.custom.use_horizontal ? "ProductItem--horizontal" : ""
  }

  function imageSize(sizes, image) {
    if (image) {
      var desired_sizes = sizes.split(",")
      var supported_sizes = ""
      for (var k = 0; k < desired_sizes.length; k++) {
        var size = desired_sizes[k]
        var size_as_int = size * 1
        if (image.width < size_as_int) {
          break
        }
        supported_sizes = supported_sizes + size + ","
      }

      if (supported_sizes == "") supported_sizes = image.width

      if (!jQ.isNumeric(supported_sizes)) {
        supported_sizes = supported_sizes.split(",").join(",")
        supported_sizes = supported_sizes.substring(0, supported_sizes.lastIndexOf(","))
      }
      return supported_sizes
    } else {
      return ""
    }
  }

  function buildPrice(data) {
    var html = ""
    var show_price_on_hover = boostPFSConfig.custom.product_show_price_on_hover
    var classPriceHover = show_price_on_hover ? "ProductItem__PriceList--showOnHover" : ""
    html += '<div class="ProductItem__PriceList ' + classPriceHover + ' ">'
    if (data.compare_at_price_min > data.price_min) {
      html +=
        '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' +
        Utils.formatMoney(data.price_min) +
        "</span> "
      html +=
        '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' +
        Utils.formatMoney(data.compare_at_price_min) +
        "</span>"
    } else {
      if (data.price_min != data.price_max) {
        html +=
          '<span class="ProductItem__Price ProductItem__Price--Light  Price">' +
          Utils.formatMoney(data.price_min) +
          "</span>"
      } else {
        html +=
          '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' +
          Utils.formatMoney(data.price_min) +
          "</span>"
      }
    }
    html += "</div>"
    return html
  }

  function buildLabels(data) {
    var html = "";
    var leftLabels = "";
    var rightLabels = "";

    if (boostPFSConfig.custom.show_labels) {
      var tags = data.tags;
      for (var k = 0; k < tags.length; k++) {
        var tag = tags[k];
        if (tag.indexOf("__label") != -1) {
          leftLabels +=
            '<span class="ProductItem__Label Heading Text--subdued">' +
            tag.split("__label:")[1] +
            "</span>";
          break;
        }
      }

      if (data.available) {
        var variants = data.variants;
        var onSale = false;
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          if (variant.compare_at_price > variant.price && variant.available) {
            onSale = true;
            break;
          }
        }
        if (onSale) {
          var percentOff = Math.round(
            ((data.compare_at_price_min - data.price_min) * 100) /
            data.compare_at_price_min
          );
          leftLabels +=
            '<span class="ProductItem__Label Heading Text--subdued">' +
            boostPFSConfig.label.sale.replace("{{ amount }}", percentOff) +
            "</span>";
        }
      } else {
        leftLabels +=
          '<span class="ProductItem__Label Heading Text--subdued">' +
          boostPFSConfig.label.sold_out +
          "</span>";
      }

      // Custom labels
      for (var i = 1; i <= 7; i++) {
        var label_collection = boostPFSConfig.custom["labels_" + i];
        if (!label_collection) continue;

        var collection = data.collections.find((c) => c.handle === label_collection);
        if (!collection) continue;

        var labels_placement = boostPFSConfig.custom["labels_placement_" + i] || "left";

        // Reset product_labels for each iteration
        var product_labels = ""; // ← FIX: Reset before building new label

        var label_url = boostPFSConfig.custom["labels_page_handle_" + i];
        if (label_url) product_labels += '<a href="' + label_url + '">';

        var label_icon = boostPFSConfig.custom["labels_icon_" + i];
        if (label_icon) {
          product_labels +=
            '<div class="ProductItem__Label ProductItem__LabelIcon Heading text--subdued LabelsBg_Color_' +
            i +
            '" >';
          product_labels += label_icon;
          product_labels += "</div>";
        }

        var label_title = boostPFSConfig.custom["labels_page_name_" + i];
        if (label_title) {
          var label_color = boostPFSConfig.custom["labels_bg_color_" + i];
          var bgClass = label_color === "rgba(0,0,0,0)" ? "LabelsNoBg" : "";

          product_labels +=
            '<span class="ProductItem__Label Heading text--subdued LabelsText_Color_' +
            i +
            " LabelsBg_Color_" +
            i +
            " " +
            bgClass +
            '">';
          product_labels += label_title;
          product_labels += "</span>";
        }

        if (label_url) product_labels += "</a>";

        if (labels_placement === "left") {
          leftLabels += product_labels;
        } else if (labels_placement === "right") {
          rightLabels += product_labels;
        }

        if (!boostPFSConfig.custom.show_multiple_custom_labels) break;
      }

      if (leftLabels !== "" || rightLabels !== "") {
        html += '<div class="tw-flex tw-justify-between ed-labels">';

        if (leftLabels !== "") {
          html += '<div class="ProductItem__LabelList">';
          html += leftLabels;
          html += "</div>";
        }

        if (rightLabels !== "") {
          html +=
            '<div class="ProductItem__LabelList !tw-left-[unset] tw-right-[10px]">';
          html += rightLabels;
          html += "</div>";
        }

        html += "</div>";
      }
    }

    return html;
  }


  function buildInfo(data, indx) {
    var html = ""
    if (boostPFSConfig.custom.show_product_info) {
      var infoClass = !boostPFSConfig.custom.use_horizontal
        ? "ProductItem__Info--" + boostPFSConfig.custom.product_info_alignment
        : ""
      html += '<div class="ProductItem__Info ' + infoClass + ' ">'
      if (boostPFSConfig.custom.show_vendor) {
        html += '<p class="ProductItem__Vendor Heading">' + data.vendor + "</p>"
      }


      console.log(data.metafields)
      // If the array of metafield objects contains a key of "alternativ_titel"

      if (data.metafields.some(metafield => metafield.key === "alternativ_titel")) {
        let dataTitleValue = data.metafields.find(metafield => metafield.key === "alternativ_titel").value
        var dataTitle = dataTitleValue
      } else {
        var dataTitle = data.title.replace("bisgaard", "")
      }




      html += '<h2 class="ProductItem__Title Heading">'
      html += '<a href="{{itemUrl}}">' + dataTitle + "</a>"
      html += "</h2>"
      html += "{{itemReviews}}"
      html += buildPrice(data)
      if (boostPFSConfig.custom.show_color_swatch) {
        html += buildSwatch(data, indx)
      }
      html += "</div>"
    }

    // edition - Build variant buttons (eg 36, 37, 38 ...)
    if (data.variants.length > 1) {
      const wrapperHolder = document.createElement("div")
      const wrapper = document.createElement("div")


      wrapperHolder.classList.add("edition-variants-wrapper-holder")
      wrapperHolder.style.position = "relative"
      wrapper.classList.add("edition-variants-wrapper")
      if (data.template_suffix === "care") {
        wrapper.classList.add('four-cols')
      }
      wrapper.classList.add("edition_scroller");

      // get all variants
      const variants = Array.from(data.variants)

      // map over variants and create buttons
      const variantsButtons = variants.map((variant) => {
        const a = document.createElement("a")
        const variantWrapper = document.createElement("span")
        variantWrapper.classList.add("edtion-variant-wrapper")

        var variantEle = document.createElement('label')
        variantEle.classList.add("edition-variant")

        // If variant is not available, add class and disable
        if (variant.inventory_quantity < 1) {
          variantEle.classList.add("edition_unavailable")
          variantEle.setAttribute('disabled', 'disabled')
        }

        // add url of variant to anchor
        let url = '/collections/' + window.theme.collectionHandle + '/' + 'products' + "/" + data.handle + '?variant=' + variant.id;
        a.setAttribute('href', url)

        variantEle.setAttribute('variant-position', variants.indexOf(variant) + 1)
        variantEle.setAttribute('variant-id', variant.id)
        variantEle.setAttribute('variant-title', variant.title)
        variantEle.setAttribute('variant-price', variant.price)
        variantEle.innerHTML = variant.title

        a.appendChild(variantEle)
        variantWrapper.appendChild(a)

        return variantWrapper
      })

      // append buttons to wrapper / html
      wrapper.append(...variantsButtons)
      wrapperHolder.appendChild(wrapper)

      let arrowRight;
      let arrowLeft;
      if ((data.variants.length > 7) || (data.template_suffix === "care" && data.variants.length > 4)) {
        arrowRight = document.createElement("edition-arrow")
        arrowRight.setAttribute("data-direction", "right")
        arrowRight.classList.add("scroller_arrow_class_visible")
        arrowRight.classList.add('!tw-right-[0px]')

        arrowLeft = document.createElement("edition-arrow")
        arrowLeft.setAttribute("data-direction", "left")
        arrowLeft.classList.add("scroller_arrow_class")
        arrowLeft.classList.add('!tw-left-[0px]')
        arrowRight.innerHTML = `<svg role="presentation" viewBox="0 0 11 18">
        <path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
        </svg>`
        arrowLeft.innerHTML = `<svg role="presentation" viewBox="0 0 11 18">
        <path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
      </svg>`

        // append arrowHolder as a sibling to wrapper
        wrapperHolder.appendChild(arrowRight)
        wrapperHolder.appendChild(arrowLeft)
      }


      html += wrapperHolder.outerHTML
    }


    return html

  }


  function promoImage(data, indx) {
    promoImageHtml = ""
    var productCount = 1
    productCount = productCount + indx
    //Promo first row - third element


    if (productCount === 3 && boostPFSTemplate.promoImageWidth_1 == "2/4" && boostPFSTemplate.promoImageUrl1x_1) {
      promoImageHtml += `<div class="Grid__Cell 2/4--lap-and-up CollectionPromo CollectionPromo--Half" >`
      if (boostPFSTemplate.promoImageLink_1) {
        promoImageHtml += `<a href="` + boostPFSTemplate.promoImageLink_1 + `">`
      }
      promoImageHtml +=
        `<div class="CollectionPromo__ImageWrapper" style="background: url(` +
        boostPFSTemplate.promoImageUrl1x_1 +
        `)">
              <div class="CollectionPromo__Image Image--lazyLoad Image--zoomOut hide-no-js AspectRatio" style="max-width: 1200px; data-expand="-25"; data-bgset="` +
        boostPFSTemplate.promoImageUrl800x_1 +
        ` [(max-width: 640px)] | ` +
        boostPFSTemplate.promoImageUrl1200x_1 +
        `"></div>

              <noscript>
                <div class="CollectionPromo__Image" style="background-image: url(` +
        boostPFSTemplate.promoImageUrl800x_1 +
        `)"></div>
              </noscript>
            </div>`
      if (boostPFSTemplate.promoImageLink_1) {
        promoImageHtml += `</a>`
      }
      promoImageHtml += `</div>`
    }

    //Promo first row - third element

    if (productCount === 3 && boostPFSTemplate.promoImageWidth_1 == "1/4" && boostPFSTemplate.promoImageUrl1x_1) {
      promoImageHtml += `<div class="Grid__Cell 1/2--phone 1/2--tablet-and-up 1/4--lap-and-up CollectionPromo CollectionPromo--Quarter" >`
      if (boostPFSTemplate.promoImageLink_1) {
        promoImageHtml += `<a href="` + boostPFSTemplate.promoImageLink_1 + `">`
      }
      promoImageHtml +=
        `<div class="CollectionPromo__ImageWrapper" style="background: url(` +
        boostPFSTemplate.promoImageUrl1x_1 +
        `)">
            <div class="CollectionPromo__Image Image--lazyLoad Image--zoomOut hide-no-js AspectRatio" style="max-width: 1200px; data-expand="-25"; data-bgset="` +
        boostPFSTemplate.promoImageUrl800x_1 +
        ` [(max-width: 640px)] | ` +
        boostPFSTemplate.promoImageUrl1200x_1 +
        `"></div>

            <noscript>
              <div class="CollectionPromo__Image" style="background-image: url(` +
        boostPFSTemplate.promoImageUrl800x_1 +
        `)"></div>
            </noscript>
          </div>`
      if (boostPFSTemplate.promoImageLink_1) {
        promoImageHtml += `</a>`
      }
      promoImageHtml += `</div>`
    }

    //Promo fourth row - first element

    var positionPromo2 = 10

    if (boostPFSTemplate.promoImageUrl1x_1) {
      positionPromo2 = 12
    }

    if (boostPFSTemplate.promoImageWidth_1 == "2/4" && boostPFSTemplate.promoImageWidth_2 == "2/4") {
      positionPromo2 = positionPromo2 - 1
    }

    if (
      productCount === positionPromo2 &&
      boostPFSTemplate.promoImageWidth_2 == "2/4" &&
      boostPFSTemplate.promoImageUrl1x_2
    ) {
      promoImageHtml += `<div class="Grid__Cell 2/4--lap-and-up CollectionPromo CollectionPromo--Half" >`
      if (boostPFSTemplate.promoImageLink_2) {
        promoImageHtml += `<a href="` + boostPFSTemplate.promoImageLink_2 + `">`
      }
      promoImageHtml +=
        `<div class="CollectionPromo__ImageWrapper" style="background: url(` +
        boostPFSTemplate.promoImageUrl1x_2 +
        `)">
              <div class="CollectionPromo__Image Image--lazyLoad Image--zoomOut hide-no-js AspectRatio" style="max-width: 1200px; data-expand="-25"; data-bgset="` +
        boostPFSTemplate.promoImageUrl800x_2 +
        ` [(max-width: 640px)] | ` +
        boostPFSTemplate.promoImageUrl1200x_2 +
        `"></div>

              <noscript>
                <div class="CollectionPromo__Image" style="background-image: url(` +
        boostPFSTemplate.promoImageUrl800x_2 +
        `)"></div>
              </noscript>
            </div>`
      if (boostPFSTemplate.promoImageLink_2) {
        promoImageHtml += `</a>`
      }
      promoImageHtml += `</div>`
    }
    //Promo fourth row - second element

    if (boostPFSTemplate.promoImageWidth_1 == "1/4" && boostPFSTemplate.promoImageWidth_2 == "1/4") {
      positionPromo2 = positionPromo2 + 1
    }

    if (
      productCount === positionPromo2 &&
      boostPFSTemplate.promoImageWidth_2 == "1/4" &&
      boostPFSTemplate.promoImageUrl1x_2
    ) {
      promoImageHtml += `<div class="Grid__Cell 1/2--phone 1/2--tablet-and-up 1/4--lap-and-up CollectionPromo CollectionPromo--Quarter" >`
      if (boostPFSTemplate.promoImageLink_2) {
        promoImageHtml += `<a href="` + boostPFSTemplate.promoImageLink_2 + `">`
      }
      promoImageHtml +=
        `<div class="CollectionPromo__ImageWrapper" style="background: url(` +
        boostPFSTemplate.promoImageUrl1x_2 +
        `)">
            <div class="CollectionPromo__Image Image--lazyLoad Image--zoomOut hide-no-js AspectRatio" style="max-width: 1200px; data-expand="-25"; data-bgset="` +
        boostPFSTemplate.promoImageUrl800x_2 +
        ` [(max-width: 640px)] | ` +
        boostPFSTemplate.promoImageUrl1200x_2 +
        `"></div>

            <noscript>
              <div class="CollectionPromo__Image" style="background-image: url(` +
        boostPFSTemplate.promoImageUrl800x_2 +
        `)"></div>
            </noscript>
          </div>`
      if (boostPFSTemplate.promoImageLink_2) {
        promoImageHtml += `</a>`
      }
      promoImageHtml += `</div>`
    }

    //Promo seventh row - third element

    //Remove one count, if previous promo is wide

    var positionPromo3 = 21
    if (boostPFSTemplate.promoImageUrl1x_1 && boostPFSTemplate.promoImageUrl1x_2) {
      positionPromo3 = 24
    }

    if (
      boostPFSTemplate.promoImageWidth_3 == "2/4" &&
      boostPFSTemplate.promoImageWidth_1 == "2/4" &&
      boostPFSTemplate.promoImageWidth_2 == "2/4"
    ) {
      positionPromo3 = positionPromo3 - 1
    }

    if (
      productCount === positionPromo3 &&
      boostPFSTemplate.promoImageWidth_3 == "2/4" &&
      boostPFSTemplate.promoImageUrl1x_3
    ) {
      promoImageHtml += `<div class="Grid__Cell 2/4--lap-and-up CollectionPromo CollectionPromo--Half" >`
      if (boostPFSTemplate.promoImageLink_3) {
        promoImageHtml += `<a href="` + boostPFSTemplate.promoImageLink_3 + `">`
      }
      promoImageHtml +=
        `<div class="CollectionPromo__ImageWrapper" style="background: url(` +
        boostPFSTemplate.promoImageUrl1x_3 +
        `)">
              <div class="CollectionPromo__Image Image--lazyLoad Image--zoomOut hide-no-js AspectRatio" style="max-width: 1200px; data-expand="-25"; data-bgset="` +
        boostPFSTemplate.promoImageUrl800x_3 +
        ` [(max-width: 640px)] | ` +
        boostPFSTemplate.promoImageUrl1200x_3 +
        `"></div>

              <noscript>
                <div class="CollectionPromo__Image" style="background-image: url(` +
        boostPFSTemplate.promoImageUrl800x_3 +
        `)"></div>
              </noscript>
            </div>`
      if (boostPFSTemplate.promoImageLink_3) {
        promoImageHtml += `</a>`
      }
      promoImageHtml += `</div>`
    }
    //Promo second row - third element

    if (
      boostPFSTemplate.promoImageWidth_3 == "1/4" &&
      boostPFSTemplate.promoImageWidth_1 == "1/4" &&
      boostPFSTemplate.promoImageWidth_2 == "1/4"
    ) {
      positionPromo3 = positionPromo3 - 1
    }

    if (productCount === positionPromo3 && boostPFSTemplate.promoImageWidth_3 == "1/4") {
      promoImageHtml += `<div class="Grid__Cell 1/2--phone 1/2--tablet-and-up 1/4--lap-and-up CollectionPromo CollectionPromo--Quarter" >`
      if (boostPFSTemplate.promoImageLink_3) {
        promoImageHtml += `<a href="` + boostPFSTemplate.promoImageLink_3 + `">`
      }
      promoImageHtml +=
        `<div class="CollectionPromo__ImageWrapper" style="background: url(` +
        boostPFSTemplate.promoImageUrl1x_3 +
        `)">
            <div class="CollectionPromo__Image Image--lazyLoad Image--zoomOut hide-no-js AspectRatio" style="max-width: 1200px; data-expand="-25"; data-bgset="` +
        boostPFSTemplate.promoImageUrl800x_3 +
        ` [(max-width: 640px)] | ` +
        boostPFSTemplate.promoImageUrl1200x_3 +
        `"></div>

            <noscript>
              <div class="CollectionPromo__Image" style="background-image: url(` +
        boostPFSTemplate.promoImageUrl800x_3 +
        `)"></div>
            </noscript>
          </div>`
      if (boostPFSTemplate.promoImageLink_3) {
        promoImageHtml += `</a>`
      }
      promoImageHtml += `</div>`
    }

    //Promo last row - first element
    var positionPromo4 = 46

    if (
      boostPFSTemplate.promoImageWidth_4 == "2/4" &&
      boostPFSTemplate.promoImageWidth_3 == "2/4" &&
      boostPFSTemplate.promoImageWidth_1 == "2/4" &&
      boostPFSTemplate.promoImageWidth_2 == "2/4"
    ) {
      positionPromo4 = positionPromo4 + 1
    }

    if (
      productCount === positionPromo4 &&
      boostPFSTemplate.promoImageWidth_4 == "2/4" &&
      boostPFSTemplate.promoImageUrl1x_4
    ) {
      promoImageHtml += `<div class="Grid__Cell 2/4--lap-and-up CollectionPromo CollectionPromo--Half" >`
      if (boostPFSTemplate.promoImageLink_4) {
        promoImageHtml += `<a href="` + boostPFSTemplate.promoImageLink_4 + `">`
      }
      promoImageHtml +=
        `<div class="CollectionPromo__ImageWrapper" style="background: url(` +
        boostPFSTemplate.promoImageUrl1x_4 +
        `)">
              <div class="CollectionPromo__Image Image--lazyLoad Image--zoomOut hide-no-js AspectRatio" style="max-width: 1200px; data-expand="-25"; data-bgset="` +
        boostPFSTemplate.promoImageUrl800x_4 +
        ` [(max-width: 640px)] | ` +
        boostPFSTemplate.promoImageUrl1200x_4 +
        `"></div>

              <noscript>
                <div class="CollectionPromo__Image" style="background-image: url(` +
        boostPFSTemplate.promoImageUrl800x_4 +
        `)"></div>
              </noscript>
            </div>`
      if (boostPFSTemplate.promoImageLink_4) {
        promoImageHtml += `</a>`
      }
      promoImageHtml += `</div>`
    }

    //Promo last row - second element

    if (
      boostPFSTemplate.promoImageWidth_4 == "1/4" &&
      boostPFSTemplate.promoImageWidth_3 == "1/4" &&
      boostPFSTemplate.promoImageWidth_1 == "1/4" &&
      boostPFSTemplate.promoImageWidth_2 == "1/4"
    ) {
      positionPromo4 = positionPromo4 + 2
    }

    if (
      productCount === positionPromo4 &&
      boostPFSTemplate.promoImageWidth_4 == "1/4" &&
      boostPFSTemplate.promoImageUrl1x_4
    ) {
      promoImageHtml += `<div class="Grid__Cell 1/2--phone 1/2--tablet-and-up 1/4--lap-and-up CollectionPromo CollectionPromo--Quarter" >`
      if (boostPFSTemplate.promoImageLink_4) {
        promoImageHtml += `<a href="` + boostPFSTemplate.promoImageLink_4 + `">`
      }
      promoImageHtml +=
        `<div class="CollectionPromo__ImageWrapper" style="background: url(` +
        boostPFSTemplate.promoImageUrl1x_4 +
        `)">
            <div class="CollectionPromo__Image Image--lazyLoad Image--zoomOut hide-no-js AspectRatio" style="max-width: 1200px; data-expand="-25"; data-bgset="` +
        boostPFSTemplate.promoImageUrl800x_4 +
        ` [(max-width: 640px)] | ` +
        boostPFSTemplate.promoImageUrl1200x_4 +
        `"></div>

            <noscript>
              <div class="CollectionPromo__Image" style="background-image: url(` +
        boostPFSTemplate.promoImageUrl800x_4 +
        `)"></div>
            </noscript>
          </div>`
      if (boostPFSTemplate.promoImageLink_4) {
        promoImageHtml += `</a>`
      }
      promoImageHtml += `</div>`
    }

    //Promo first row - third element
    return promoImageHtml
  }

  function buildSwatch(data, indx) {
    var itemSwatchHtml = ""
    if (boostPFSConfig.custom.show_color_swatch) {
      var color_name = boostPFSConfig.custom.section_id + "-" + data.id + "-" + indx
      data.options_with_values.forEach(function (option, index) {
        var option_name = option.name.toLowerCase()
        if (
          option_name.indexOf("color") != -1 ||
          option_name.indexOf("colour") != -1 ||
          option_name.indexOf("couleur") != -1
        ) {
          var values = ""
          itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">'
          var i = 0
          data.variants.forEach(function (variant) {
            var temp = variant.merged_options.filter(function (obj) {
              obj = obj.toLowerCase()
              if (obj.indexOf("color") != -1 || obj.indexOf("colour") != -1 || obj.indexOf("couleur") != -1) return obj
            })
            temp = temp[0].split(":")

            var value = temp[1].toLowerCase()
            if (values.indexOf(value) == -1) {
              values = values + "," + value
              values = values.split(",")
              var size = "200,400,600,700,800,900,1000,1200"
              var supported_sizes = imageSize(size, variant.image)
              var color_image = Utils.optimizeImage(variant.image)
              var name_color = Utils.slugify(value) + ".png"
              var checked = i == 0 ? "checked=checked" : ""
              var imageInfo = null
              var image_aspect_ratio = 1
              imageInfo = data.images_info.find(function (imageOb) {
                if (imageOb.src == variant.image) {
                  image_aspect_ratio = imageOb.width / imageOb.height
                  return imageOb
                }
              })
              if (!imageInfo) {
                if (data.images_info.length > 0) {
                  imageInfo = data.images_info[0]
                } else {
                  imageInfo = {
                    src: boostPFSConfig.general.no_image_url,
                    id: variant.id,
                    width: 480,
                    height: 480,
                  }
                }
              }
              var dataImg =
                imageInfo != null
                  ? '" data-image-url="' +
                  imageInfo.src +
                  '" data-image-widths="[' +
                  supported_sizes +
                  ']" data-image-aspect-ratio="1" data-image-id="' +
                  imageInfo.id +
                  '"'
                  : ""
              var color_input_id = color_name + "-" + values.length
              var variant_price = variant.price ? variant.price : 0
              var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0
              var url_color = Utils.getFilePath(
                Utils.slugify(value),
                Globals.swatchExtension,
                Settings.getSettingValue("general.swatchImageVersion")
              )
              itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">'
              itemSwatchHtml +=
                '<input class="ColorSwatch__Radio" type="radio" ' +
                checked +
                ' name="' +
                color_name +
                '" id="' +
                color_input_id +
                '" value="' +
                value +
                '" data-image-aspect-ratio="' +
                image_aspect_ratio +
                '" data-variant-price="' +
                variant_price +
                '" data-variant-compare-at-price="' +
                variant_compare_at_price +
                '" data-variant-url="' +
                Utils.buildProductItemUrl(data) +
                "?variant=" +
                variant.id +
                "#Image" +
                imageInfo.id +
                '"' +
                dataImg +
                '  aria-hidden="true">'
              itemSwatchHtml +=
                '<label class="ColorSwatch ColorSwatch--small" for="' +
                color_input_id +
                '" style="background-color: ' +
                value.replace(" ", "").toLowerCase() +
                "; background-image: url(" +
                url_color +
                ')" title="' +
                value +
                '" data-tooltip="' +
                value +
                '"></label>'
              itemSwatchHtml += "</div>"
              i++
            }
          })
          itemSwatchHtml += "</div>"
        }
      })
    }
    return itemSwatchHtml
  }
  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page)
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit)

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml
      // Build Previous
      var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage - 1))
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml)
      // Build Next
      var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage + 1))
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)
      // Create page items array
      var beforeCurrentPageArr = []
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore)
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...")
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1)
      }
      beforeCurrentPageArr.push(currentPage)
      var afterCurrentPageArr = []
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter)
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...")
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage)
      }
      // Build page items
      var pageItemsHtml = ""
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage])
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
        )
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml)
      return paginationHtml
    }

    return ""
  }

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = ""
    if (boostPFSConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList()
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = ""
        for (var k in sortingArr) {
          var classActive = Globals.queryParams.sort == k ? "is-selected" : ""
          sortingItemsHtml +=
            '<button class="Popover__Value ' +
            classActive +
            ' Heading Link Link--primary u-h6" data-value="' +
            k +
            '">' +
            sortingArr[k] +
            "</button>"
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml)
      }
    }
    return html
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var topSortingSelector = jQ(Selector.topSorting)
    topSortingSelector.find(".Popover__Value").click(function (e) {
      FilterApi.setParam("sort", jQ(this).data("value"))
      FilterApi.setParam("page", 1)
      FilterApi.applyFilter("sort")
      jQ(".CollectionToolbar__Item--sort").trigger("click")
    })
  }
  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data
    if (!eventType) eventType = this.eventType
    /**
     *  Call theme function
     *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
     *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
     *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;
   
    if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
    bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
    bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
    }
    */

    this.buildExtrasProductListByAjax(data, "boost-integration", function (results) {
      results.forEach(function (result) {
        if (result.custom_html && result.custom_html.trim()) {
          jQ('[data-product-id="' + result.id + '"]')
            .find(".ProductItem__Info")
            .html(result.custom_html.trim())
        }
      })
    })

    // Fix image not load on Instagram browser - initialize swatch image
    jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(
      function () {
        jQ(this).parent().parent().find("label.ColorSwatch").removeClass("active")
        jQ(this).addClass("active")
        var parent = jQ(this).parent()
        var productImage = jQ(this).parent().parent().parent().parent().find("a.ProductItem__ImageWrapper")
        var variantInfo = parent.find("input.ColorSwatch__Radio")
        productImage.find(".AspectRatio .bc-sf-product-swatch-img").remove()
        productImage
          .find(".AspectRatio")
          .prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data("image-url") + '" />')
        productImage.find("img.ProductItem__Image").hide()
        productImage.attr("href", variantInfo.data("variant-url"))
        var variantPrice = ""
        if (variantInfo.data("variant-compare-at-price") > variantInfo.data("variant-price")) {
          variantPrice +=
            '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' +
            Utils.formatMoney(variantInfo.data("variant-price")) +
            "</span>"
          variantPrice +=
            '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' +
            Utils.formatMoney(variantInfo.data("variant-compare-at-price")) +
            "</span>"
        } else {
          variantPrice +=
            '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' +
            Utils.formatMoney(variantInfo.data("variant-price")) +
            "</span>"
        }
        jQ(this).closest(".ProductItem__Wrapper").find(".ProductItem__PriceList").html(variantPrice)
      }
    )

    //Change view layout
    var desktopView = jQ(".CollectionToolbar__LayoutSwitch.hidden-phone").find(".is-active").data("count")
    if (desktopView && desktopView != parseInt(boostPFSConfig.custom.desktop_row)) {
      jQ(Selector.products + " .Grid__Cell").removeClass(
        "1/" +
        boostPFSConfig.custom.tablet_row +
        "--tablet-and-up 1/" +
        boostPFSConfig.custom.desktop_row +
        "--" +
        buildClass()
      )
      jQ(Selector.products + " .Grid__Cell").addClass(
        "1/" + desktopView + "--tablet-and-up 1/" + desktopView + "--" + buildClass()
      )
    }
    var mobileView = jQ(".CollectionToolbar__LayoutSwitch.hidden-tablet-and-up").find(".is-active").data("count")
    if (mobileView && mobileView != parseInt(boostPFSConfig.custom.mobile_row)) {
      jQ(Selector.products + " .Grid__Cell").removeClass("1/" + boostPFSConfig.custom.mobile_row + "--phone")
      jQ(Selector.products + " .Grid__Cell").addClass("1/" + mobileView + "--phone")
    }
  }

  // Build additional elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data
    if (!eventType) eventType = this.eventType


    let totalProducts = document.querySelectorAll('.amount_products')
    for (let total of totalProducts) {
      total.style.textTransform = 'uppercase'
      total.style.fontSize = '12px'
      total.style.fontWeight = 'bold'
      total.innerText = data.total_product
    }

    /* start-boost-custom */
    /* #boost-146495: implement progress bar */
    var currentPage = parseInt(Globals.queryParams.page)
    var totalPage = Math.ceil(data.total_product / Globals.queryParams.limit)
    var progress = (currentPage / totalPage) * 100

    jQ("#AjaxinateProgress").css("width", progress + "%")
    /* end-boost-custom */
  }

  //Boost 156718
  FilterApi.beforeCall = function (result, eventType, eventInfo) {
    if (eventType == "history") {
      window.location.reload()
    }
  }

  var applyFilter = FilterApi.applyFilter

  FilterApi.applyFilter = function (eventType, eventInfo) {
    if (eventType !== "collection") applyFilter.call(this, eventType, eventInfo)
    else {
      var url = Navigation.buildAddressBarUrl()
      window.location = url
    }
  }
  //End Boost 156718

  // Fix description issue
  PageInfoCollection.prototype.buildCollectionDetail = function () {
    if (typeof this.collectionData !== "undefined" && this.collectionData.hasOwnProperty("collection")) {
      // Get collection info
      var collectionInfo = this.collectionData.collection
      var title = collectionInfo.hasOwnProperty("title") && collectionInfo.title != "" ? collectionInfo.title : null
      var description =
        collectionInfo.hasOwnProperty("description") && collectionInfo.description != ""
          ? collectionInfo.description
          : null
      var image =
        collectionInfo.hasOwnProperty("image") && collectionInfo.image && collectionInfo.image.src
          ? collectionInfo.image.src
          : null
      // Build Collection Title
      if (title) {
        this.$collectionHeader.html(Utils.stripHtml(title)).show()
      } else {
        this.$collectionHeader.hide()
      }
      // Build Collection Description
      // console.log(description);
      let newDescArr = description.split("####")
      let newDesc = description
      if (newDescArr.length > 0) {
        newDesc = newDescArr[0]
      }

      if (description) {
        this.$collectionDescription.html(newDesc).show()
      } else {
        this.$collectionDescription.hide()
      }
      // Build Collection Image
      if (image && !Utils.isBadUrl(image)) {
        this.$collectionImage
          .attr("src", image)
          .css("background-image", "url(" + image + ")")
          .removeClass(Class.collectionNoImage)
          .addClass(Class.collectionHasImage)
      } else {
        this.$collectionImage
          .attr("src", "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==")
          .css("background-image", "none")
          .removeClass(Class.collectionHasImage)
          .addClass(Class.collectionNoImage)
      }
    }
  }
  // End Fix description issue

  // Build Default layout
  Filter.prototype.errorFilterCallback = function () {
    var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
      isSafari = /Safari/.test(navigator.userAgent),
      isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type
    if (!(isiOS && isSafari && isBackButton)) {
      var self = this,
        url = window.location.href.split("?")[0],
        searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : ""
      window.location.replace(url + "?view=bc-original" + searchQuery)
    }
  }
})()
